/**
 * PEN-01 on Game Detail: Penelope's "may she buy this team" switch in the caption row of that team's own expanded
 * book (Doom's yellow squares, R1 Exhibit 2). Shares state with the ticket's Penelope tab through the page's
 * PenelopeSidesProvider, and only exists — and only polls — on the series she runs on, for a member she is on for.
 */
import { penelopeEventTicker } from '@/hooks/usePenelope';
import { usePenelopeAccess } from '@/hooks/usePenelopeAccess';
import { PENELOPE_EVENT_PREFIXES, usePenelopeSides } from '@/hooks/usePenelopeSides';
import { PenelopeSideToggle } from '@/views/LiveGame/PenelopeSideToggle';
import { PenelopeAnchorStrip } from '@/views/LiveGame/PenelopeAnchor';
import { PenelopeWhyFor } from '@/views/LiveGame/PenelopeWhy';
import type { GameRow, TeamSide } from '@/views/ValueDashboard/types';

export function PenelopeBookSwitch({ game, teamSide }: { game: GameRow; teamSide: TeamSide }) {
  const access = usePenelopeAccess();
  const event = penelopeEventTicker(game);
  const supported = event !== null && PENELOPE_EVENT_PREFIXES.some((p) => event.startsWith(p));
  const sides = usePenelopeSides(game, access && supported);
  if (!access || !supported) return null;
  const away = teamSide === 'away';
  const toggle = <PenelopeSideToggle sides={sides} side={away ? 'A' : 'B'} teamCode={away ? game.awayCode : game.homeCode} otherCode={away ? game.homeCode : game.awayCode} compact />;
  // R10 "Why?" for this team, once her row runs (an empty side says what is stopping it).
  const why = <PenelopeWhyFor row={sides.control.game} team={away ? 'A' : 'B'} teamA={game.awayCode} teamB={game.homeCode} />;
  // R8 evidence anchor: once per page, on the away book (PT time, clock, score, settings version).
  if (!away) return <span className="flex items-center gap-1">{toggle}{why}</span>;
  return (
    <span className="flex min-w-0 items-center gap-2">
      <PenelopeAnchorStrip game={game} row={sides.control.game} compact className="max-w-[22rem]" />
      {toggle}
      {why}
    </span>
  );
}
